/**
 * ==========================================
 * 共通初期化
 * - 通常表示
 * - Shopifyテーマエディタ再描画時
 * ==========================================
 */
(function () {
    /**
     * ========================================
     * ページ全体の初期化
     * ========================================
     */
    function initAll() {
        initHeaderScroll();
        initMegaMenu();
        initSearch();
        initDrawer();
    }

    /**
     * ========================================
     * 通常表示時の初期化
     * ========================================
     */
    document.addEventListener('DOMContentLoaded', function () {
        initAll();
    });

    /**
     * ========================================
     * Shopifyテーマエディタでの再初期化
     * - セクション再読み込み時にも動くようにする
     * ========================================
     */
    document.addEventListener('shopify:section:load', function () {
        initAll();
    });

    /**
     * ========================================
     * ヘッダースクロールで下部メニュー表示制御
     * ========================================
     */
    function initHeaderScroll() {
        const headerTop = document.querySelector('.js-header-top');
        const headerTopWrap = document.querySelector('.js-header-top-wrap');
        const headerBottom = document.querySelector('.js-header-bottom');
        const headerWave = document.querySelector('.p-custom-header__wave');
        const bottomNav = document.querySelector('.js-bottom-nav');
        const mrpointEmbed = document.querySelector('.mrpoint-embed.js-container');
        const collectionFilter = document.querySelector('.collection-hero__filter-slot');
        const searchFilter = document.querySelector('.search-hero__filter-slot');
        const fixBanner = document.querySelector('.c-fix-banner');
        let fixBannerOriginalBottom = 0;
        if (mrpointEmbed) {
            mrpointEmbed.style.transition = 'transform 0.2s ease';
        }
        if (collectionFilter) {
            collectionFilter.style.transition = 'transform 0.2s ease';
        }
        if (searchFilter) {
            searchFilter.style.transition = 'transform 0.2s ease';
        }
        if (fixBanner) {
            fixBannerOriginalBottom = parseInt(getComputedStyle(fixBanner).bottom, 10) || 0;
            fixBanner.style.transition = 'transform 0.3s ease, bottom 0.2s ease';
        }
        const announcementBar = document.querySelector('.announcement-bar-section');
        const megaMenu = document.querySelector('.js-mega-menu');
        const drawer = document.querySelector('.p-custom-drawer');

        if (!headerTop && !headerBottom) return;

        const initTarget = headerTop || headerBottom;
        if (initTarget.dataset.scrollInitialized === 'true') return;
        initTarget.dataset.scrollInitialized = 'true';

        let lastScrollY = window.scrollY;
        let ticking = false;

        const pcDownThreshold = 20;
        const pcUpThreshold = 10;
        const spHideThreshold = 80;
        const breakpoint = 989;

        let pcDownStartY = window.scrollY;
        let pcUpStartY = window.scrollY;
        let spDownStartY = window.scrollY;
        let spUpStartY = window.scrollY;

        /**
         * ========================================
         * PC / SP 判定
         * ========================================
         */
        function isPc() {
            return window.innerWidth >= breakpoint + 1;
        }

        function isSp() {
            return window.innerWidth <= breakpoint;
        }

        /**
         * ========================================
         * メニュー開閉状態
         * ========================================
         */
        function isMegaMenuOpen() {
            return megaMenu && megaMenu.classList.contains('is-open');
        }

        function isDrawerOpen() {
            return drawer && drawer.classList.contains('is-open');
        }

        /**
         * ========================================
         * 告知バー高さ
         * ========================================
         */
        function getAnnouncementHeight() {
            if (!announcementBar) return 0;
            return announcementBar.offsetHeight;
        }

        /**
         * ========================================
         * SPヘッダーのプレースホルダー高さ
         * ========================================
         */
        function setSpHeaderPlaceholder() {
            if (!headerTop || !headerTopWrap) return;
            headerTopWrap.style.height = headerTop.offsetHeight + 'px';
        }

        function clearSpHeaderPlaceholder() {
            if (!headerTopWrap) return;
            headerTopWrap.style.height = '';
        }

        /**
         * ========================================
         * PC時：bottom表示 / 非表示（waveも連動）
         * ========================================
         */
        function showPcHeader() {
            if (headerBottom) {
                headerBottom.classList.remove('is-hidden');
            }
            if (headerWave) {
                headerWave.classList.remove('is-hidden');
            }
        }

        function hidePcHeader() {
            if (headerBottom) {
                headerBottom.classList.add('is-hidden');
            }
            if (headerWave) {
                headerWave.classList.add('is-hidden');
            }
        }

        /**
         * ========================================
         * SP時：top制御
         * ========================================
         */
        function resetSpHeader() {
            if (!headerTop) return;

            headerTop.classList.remove('is-fixed');
            headerTop.classList.remove('is-hidden');
            clearSpHeaderPlaceholder();

            if (bottomNav) {
                bottomNav.classList.remove('is-hidden');
            }

            if (mrpointEmbed) {
                mrpointEmbed.style.transform = 'translateY(-6rem)';
            }

            if (fixBanner) {
                fixBanner.style.bottom = (fixBannerOriginalBottom + 20) + 'px';
            }
        }

        function fixSpHeader() {
            if (!headerTop) return;

            setSpHeaderPlaceholder();
            headerTop.classList.add('is-fixed');
            headerTop.classList.remove('is-hidden');
        }

        function showSpHeader() {
            if (!headerTop) return;

            setSpHeaderPlaceholder();
            headerTop.classList.add('is-fixed');
            headerTop.classList.remove('is-hidden');

            if (bottomNav) {
                bottomNav.classList.remove('is-hidden');
            }

            if (mrpointEmbed) {
                mrpointEmbed.style.transform = 'translateY(-6rem)';
            }

            if(collectionFilter) {
                collectionFilter.style.transform = 'translateY(-6rem)';
            }
            if(searchFilter) {
                searchFilter.style.transform = 'translateY(-6rem)';
            }

            if (fixBanner) {
                fixBanner.style.bottom = (fixBannerOriginalBottom + 20) + 'px';
            }
        }

        function hideSpHeader() {
            if (!headerTop) return;
            if (!headerTop.classList.contains('is-fixed')) return;

            headerTop.classList.add('is-hidden');

            if (bottomNav) {
                bottomNav.classList.add('is-hidden');
            }

            if (mrpointEmbed) {
                mrpointEmbed.style.transform = 'translateY(0)';
            }

            if(collectionFilter) {
                collectionFilter.style.transform = 'translateY(0)';
            }

            if(searchFilter) {
                searchFilter.style.transform = 'translateY(0)';
            }

            if (fixBanner) {
                fixBanner.style.bottom = fixBannerOriginalBottom + 'px';
            }
        }

        /**
         * ========================================
         * 初期表示時のヘッダー状態制御
         * - CSSで初期状態を設定しているものを適切に制御
         * - スクロール位置に応じて表示/非表示・背景を設定
         * - その後トランジションを有効化
         * ========================================
         */
        function initializeHeaderState() {
            const currentScrollY = window.scrollY;

            // headerTop の初期化
            if (headerTop) {
                headerTop.removeAttribute('data-initial-check');

                if (currentScrollY > 0) {
                    headerTop.classList.add('is-scrolled');
                } else {
                    headerTop.classList.remove('is-scrolled');
                }

                // トランジションを有効化
                requestAnimationFrame(function() {
                    requestAnimationFrame(function() {
                        headerTop.classList.add('is-initialized');
                    });
                });
            }

            // headerBottom の初期化
            if (headerBottom) {
                headerBottom.removeAttribute('data-initial-check');

                if (isPc()) {
                    const topHeight = headerTop ? headerTop.offsetHeight : 0;

                    // ページ上部の場合は表示、それ以外は非表示
                    if (currentScrollY <= topHeight) {
                        headerBottom.classList.remove('is-hidden');
                        headerBottom.style.transform = '';
                        if (headerWave) {
                            headerWave.classList.remove('is-hidden');
                        }
                    } else {
                        headerBottom.classList.add('is-hidden');
                        if (headerWave) {
                            headerWave.classList.add('is-hidden');
                        }
                    }
                } else {
                    // SP時は非表示状態を解除
                    headerBottom.style.transform = '';
                    headerBottom.classList.remove('is-hidden');
                }

                // トランジションを有効化
                requestAnimationFrame(function() {
                    requestAnimationFrame(function() {
                        headerBottom.classList.add('is-initialized');
                    });
                });
            }
        }

        // 初期状態を設定
        initializeHeaderState();

        /**
         * ========================================
         * リサイズ時の見た目リセット
         * ========================================
         */
        function resetHeaderVisibilityByMode() {
            if (isPc()) {
                if (headerTop) {
                    headerTop.classList.remove('is-fixed');
                    headerTop.classList.remove('is-hidden');
                }

                clearSpHeaderPlaceholder();
            }

            if (isSp()) {
                if (headerBottom) {
                    headerBottom.classList.remove('is-hidden');
                }
            }
        }

        /**
         * ========================================
         * PC時スクロール制御
         * ========================================
         */
        function handlePcScroll(currentScrollY) {
            const topHeight = headerTop ? headerTop.offsetHeight : 0;

            // ページ上部またはメガメニュー表示時は表示
            if (currentScrollY <= topHeight || isMegaMenuOpen()) {
                showPcHeader();
                pcDownStartY = currentScrollY;
                return;
            }

            // 下スクロール時のみ非表示（上スクロールでは再表示しない）
            if (currentScrollY > lastScrollY) {
                if (currentScrollY - pcDownStartY > pcDownThreshold) {
                    hidePcHeader();
                }
            } else {
                // 上スクロール時は閾値をリセットするのみ
                pcDownStartY = currentScrollY;
            }
        }

        /**
         * ========================================
         * SP時スクロール制御
         * - 告知バー高さを超えたら fixed
         * - さらに一定量で hidden
         * ========================================
         */
        function handleSpScroll(currentScrollY) {
            const announcementHeight = getAnnouncementHeight();

            /**
             * 告知バーの高さ以内では通常状態
             */
            if (currentScrollY <= announcementHeight) {
                resetSpHeader();
                spDownStartY = currentScrollY;
                spUpStartY = currentScrollY;
                return;
            }

            /**
             * ドロワーが開いている時は常に表示固定
             */
            if (isDrawerOpen()) {
                showSpHeader();
                spDownStartY = currentScrollY;
                spUpStartY = currentScrollY;
                return;
            }

            /**
             * 告知バーを超えたら stickyっぽく固定
             */
            fixSpHeader();

            /**
             * 下スクロール
             * - 一定量進んだら hidden
             */
            if (currentScrollY > lastScrollY) {
                spUpStartY = currentScrollY;

                if (currentScrollY - spDownStartY > spHideThreshold) {
                    hideSpHeader();
                }
            }

            /**
             * 上スクロール
             * - 少し戻したら再表示
             */
            if (currentScrollY < lastScrollY) {
                spDownStartY = currentScrollY;

                if (spUpStartY - currentScrollY > 10) {
                    showSpHeader();
                }
            }
        }

        /**
         * ========================================
         * メインスクロール処理
         * ========================================
         */
        function handleScroll() {
            const currentScrollY = window.scrollY;

            // ヘッダー背景色の切り替え
            if (headerTop) {
                if (currentScrollY > 0) {
                    headerTop.classList.add('is-scrolled');
                } else {
                    headerTop.classList.remove('is-scrolled');
                }
            }

            if (isPc()) {
                handlePcScroll(currentScrollY);
            }

            if (isSp()) {
                handleSpScroll(currentScrollY);
            }

            lastScrollY = currentScrollY;
            ticking = false;
        }

        /**
         * ========================================
         * スクロールイベント
         * ========================================
         */
        window.addEventListener(
            'scroll',
            function () {
                if (!ticking) {
                    window.requestAnimationFrame(handleScroll);
                    ticking = true;
                }
            },
            { passive: true }
        );

        /**
         * ========================================
         * リサイズ時
         * ========================================
         */
        window.addEventListener('resize', function () {
            resetHeaderVisibilityByMode();
        });
    }

    /**
     * ========================================
     * ヘッダーメガメニュー制御
     * ========================================
     */
    function initMegaMenu() {
        const navItems = document.querySelectorAll('.p-custom-header__nav-item');

        // 対象がなければ終了
        if (!navItems.length) return;

        // すでに初期化済みなら終了
        const notInitializedItems = Array.from(navItems).filter(function (menuItem) {
            return menuItem.dataset.megaInitialized !== 'true';
        });

        if (!notInitializedItems.length) return;

        let closeTimer = null;
        let currentOpenItem = null;

        /**
         * 閉じる予約タイマー解除
         */
        function clearCloseTimer() {
            if (closeTimer) {
                clearTimeout(closeTimer);
                closeTimer = null;
            }
        }

        /**
         * 指定メニュー内のパネルを全解除
         */
        function clearPanels(menuItem) {
            const panels = menuItem.querySelectorAll('.p-mega-menu__panel');

            panels.forEach(function (panel) {
                panel.classList.remove('is-active');
            });
        }

        /**
         * 指定メニュー内のカテゴリ current を全解除
         */
        function clearCurrent(menuItem) {
            const catItems = menuItem.querySelectorAll('.p-mega-menu__cat-item');

            catItems.forEach(function (item) {
                item.classList.remove('is-current');
            });
        }

        /**
         * directメニューの最初のパネルを表示
         */
        function activateDirectPanel(menuItem) {
            const firstPanel = menuItem.querySelector('.p-mega-menu__panel');

            if (!firstPanel) return;

            clearPanels(menuItem);
            firstPanel.classList.add('is-active');
        }

        /**
         * menuId に対応するカテゴリとパネルを表示
         */
        function activateCategoryPanel(menuItem, menuId) {
            if (!menuId) return;

            clearCurrent(menuItem);
            clearPanels(menuItem);

            const targetTrigger = menuItem.querySelector('.js-mega-cat-trigger[data-menu-id="' + menuId + '"]');
            const targetPanel = menuItem.querySelector('.p-mega-menu__panel[data-menu-id="' + menuId + '"]');

            if (targetTrigger) {
                const targetItem = targetTrigger.closest('.p-mega-menu__cat-item');

                if (targetItem) {
                    targetItem.classList.add('is-current');
                }
            }

            if (targetPanel) {
                targetPanel.classList.add('is-active');
            }
        }

        /**
         * ハンバーガーメニューの最初のカテゴリを表示
         */
        function activateFirstCategoryPanel(menuItem) {
            const firstTrigger = menuItem.querySelector('.js-mega-cat-trigger');

            if (!firstTrigger) return;

            activateCategoryPanel(menuItem, firstTrigger.dataset.menuId);
        }

        /**
         * 指定メニューを閉じる
         */
        function closeMenuItem(menuItem) {
            if (!menuItem) return;

            const trigger = menuItem.querySelector('.js-nav-trigger');
            const megaMenu = menuItem.querySelector('.js-mega-menu');

            menuItem.classList.remove('is-open');

            if (trigger) {
                trigger.setAttribute('aria-expanded', 'false');
            }

            if (megaMenu) {
                megaMenu.setAttribute('aria-hidden', 'true');
            }

            clearCurrent(menuItem);
            clearPanels(menuItem);

            // 背景スクロール解除
            document.body.classList.remove('mega-menu-open');
        }

        /**
         * 全メニューを閉じる
         */
        function closeAllMenuItems() {
            navItems.forEach(function (menuItem) {
                closeMenuItem(menuItem);
            });

            currentOpenItem = null;

            // 背景スクロール解除
            document.body.classList.remove('mega-menu-open');
        }

        /**
         * 指定メニューを開く
         */
        function openMenuItem(menuItem) {
            if (!menuItem) return;

            const trigger = menuItem.querySelector('.js-nav-trigger');
            const megaMenu = menuItem.querySelector('.js-mega-menu');

            if (!trigger || !megaMenu) return;

            if (currentOpenItem && currentOpenItem !== menuItem) {
                closeMenuItem(currentOpenItem);
            }

            menuItem.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            megaMenu.setAttribute('aria-hidden', 'false');

            currentOpenItem = menuItem;

            // 背景スクロール禁止
            document.body.classList.add('mega-menu-open');
        }

        /**
         * 指定メニューを少し遅れて閉じる
         */
        function reserveCloseMenuItem(menuItem) {
            clearCloseTimer();

            closeTimer = setTimeout(function () {
                closeMenuItem(menuItem);

                if (currentOpenItem === menuItem) {
                    currentOpenItem = null;
                }
            }, 120);
        }

        /**
         * タッチ操作フラグ（タッチ後のclickイベント重複防止）
         */
        let touchHandled = false;

        /**
         * 各メニュー項目ごとのイベント設定
         */
        notInitializedItems.forEach(function (menuItem) {
            menuItem.dataset.megaInitialized = 'true';

            const trigger = menuItem.querySelector('.js-nav-trigger');
            const megaMenu = menuItem.querySelector('.js-mega-menu');
            const closeButton = menuItem.querySelector('.js-mega-close');
            const catTriggers = menuItem.querySelectorAll('.js-mega-cat-trigger');

            if (!trigger || !megaMenu) return;

            const hasCategorySwitch = catTriggers.length > 0;

            /**
             * メニュートグル処理
             */
            function toggleMenu() {
                if (menuItem.classList.contains('is-open')) {
                    closeMenuItem(menuItem);
                    currentOpenItem = null;
                } else {
                    openMenuItem(menuItem);
                    if (hasCategorySwitch) {
                        activateFirstCategoryPanel(menuItem);
                    } else {
                        activateDirectPanel(menuItem);
                    }
                }
            }

            // ハンバーガーメニュー型：カテゴリ切替は開いた状態のままホバーで切替可能に
            if (hasCategorySwitch) {
                catTriggers.forEach(function (catTrigger) {
                    catTrigger.addEventListener('mouseenter', function () {
                        // メニューが開いている時のみカテゴリを切り替え
                        if (!menuItem.classList.contains('is-open')) return;
                        const menuId = this.dataset.menuId;
                        activateCategoryPanel(menuItem, menuId);
                    });
                });
            }

            // タッチ位置追跡（スクロールとタップを区別）
            let touchStartX = 0;
            let touchStartY = 0;
            let isTapValid = false;
            const TAP_THRESHOLD = 10; // ピクセル以内の移動ならタップと判定

            // touchstartで開始位置を記録
            trigger.addEventListener('touchstart', function (e) {
                touchHandled = true;
                isTapValid = true;
                if (e.touches.length > 0) {
                    touchStartX = e.touches[0].clientX;
                    touchStartY = e.touches[0].clientY;
                }
            }, { passive: true });

            // touchmoveで移動量をチェック
            trigger.addEventListener('touchmove', function (e) {
                if (!isTapValid) return;
                if (e.touches.length > 0) {
                    const moveX = Math.abs(e.touches[0].clientX - touchStartX);
                    const moveY = Math.abs(e.touches[0].clientY - touchStartY);
                    // 閾値を超えたらスクロールと判断
                    if (moveX > TAP_THRESHOLD || moveY > TAP_THRESHOLD) {
                        isTapValid = false;
                    }
                }
            }, { passive: true });

            // touchendでタップの場合のみメニュートグル
            trigger.addEventListener('touchend', function (e) {
                // タップと判定された場合のみ実行
                if (isTapValid) {
                    e.preventDefault();
                    toggleMenu();
                }

                // 一定時間後にフラグをリセット
                setTimeout(function () {
                    touchHandled = false;
                    isTapValid = false;
                }, 400);
            });

            // clickでメニュートグル（PC用、タッチ後は無視）
            trigger.addEventListener('click', function (e) {
                // タッチで既に処理済みなら無視
                if (touchHandled) {
                    e.preventDefault();
                    return;
                }
                e.preventDefault();
                toggleMenu();
            });

            // ×ボタン
            if (closeButton) {
                closeButton.addEventListener('touchend', function (e) {
                    e.preventDefault();
                    closeMenuItem(menuItem);
                    if (currentOpenItem === menuItem) {
                        currentOpenItem = null;
                    }
                });

                closeButton.addEventListener('click', function (e) {
                    e.preventDefault();
                    closeMenuItem(menuItem);
                    if (currentOpenItem === menuItem) {
                        currentOpenItem = null;
                    }
                });
            }
        });

        /**
         * Escキーで全閉じ
         */
        if (document.body.dataset.megaEscInitialized !== 'true') {
            document.body.dataset.megaEscInitialized = 'true';

            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') {
                    closeAllMenuItems();
                }
            });
        }

        /**
         * メニュー外クリックで全閉じ
         */
        if (document.body.dataset.megaOutsideInitialized !== 'true') {
            document.body.dataset.megaOutsideInitialized = 'true';

            document.addEventListener('click', function (e) {
                // 開いているメニューがなければ何もしない
                const openItem = document.querySelector('.p-custom-header__nav-item.is-open');
                if (!openItem) return;

                // クリックがナビ項目内なら無視（トグル処理に任せる）
                if (e.target.closest('.p-custom-header__nav-item')) return;

                closeAllMenuItems();
            });
        }
    }

    /**
     * ========================================
     * 検索モーダル制御
     * ========================================
     */
    function initSearch() {
        const search = document.querySelector('.p-custom-search');

        // 対象がなければ終了
        if (!search) return;

        // 二重初期化防止
        if (search.dataset.searchInitialized === 'true') return;
        search.dataset.searchInitialized = 'true';

        const openTriggers = document.querySelectorAll('.js-search-open');
        const closeTriggers = search.querySelectorAll('.js-search-close');
        const defaultContent = search.querySelector('.js-search-default');
        const detailContent = search.querySelector('.js-search-detail');
        const detailToggleButtons = search.querySelectorAll('.js-search-detail-toggle');
        const tabs = search.querySelectorAll('.p-custom-search__tab');
        const panels = search.querySelectorAll('.p-custom-search__panel');

        /**
         * 通常検索画面を表示
         */
        function showDefaultContent() {
            if (defaultContent) {
                defaultContent.classList.add('is-active');
            }

            if (detailContent) {
                detailContent.classList.remove('is-active');
            }
        }

        /**
         * 詳細検索画面を表示
         */
        function showDetailContent() {
            if (defaultContent) {
                defaultContent.classList.remove('is-active');
            }

            if (detailContent) {
                detailContent.classList.add('is-active');
            }
        }

        /**
         * 両画面とも非表示に戻す
         */
        function resetSearchContent() {
            if (defaultContent) {
                defaultContent.classList.remove('is-active');
            }

            if (detailContent) {
                detailContent.classList.remove('is-active');

            }
        }

        /**
         * タブ切替
         */
        function switchTab(tabName) {
            if (!tabName) return;

            tabs.forEach(function (tab) {
                const isTarget = tab.dataset.tab === tabName;
                tab.classList.toggle('is-active', isTarget);
            });

            panels.forEach(function (panel) {
                const isTarget = panel.dataset.panel === tabName;
                panel.classList.toggle('is-active', isTarget);
            });
        }

        /**
         * 検索モーダルを開く
         */
        function openSearch() {
            search.classList.add('is-open');
            search.setAttribute('aria-hidden', 'false');
            document.documentElement.classList.add('is-search-open');
            showDefaultContent();
            switchTab('category');
        }

        /**
         * 検索モーダルを閉じる
         */
        function closeSearch() {
            search.classList.remove('is-open');
            search.setAttribute('aria-hidden', 'true');
            document.documentElement.classList.remove('is-search-open');

            resetSearchContent();
            switchTab('category');
        }

        /**
         * 初期状態
         * - 閉じている時は両画面とも非active
         */
        resetSearchContent();
        switchTab('category');

        /**
         * 開く
         */
        openTriggers.forEach(function (trigger) {
            trigger.addEventListener('click', function (e) {
                e.preventDefault();
                openSearch();
            });
        });

        /**
         * 閉じる
         */
        closeTriggers.forEach(function (trigger) {
            trigger.addEventListener('click', function (e) {
                e.preventDefault();
                closeSearch();
            });
        });

        /**
         * 詳細検索へ切替
         */
        detailToggleButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                showDetailContent();
            });
        });

        /**
         * タブ切替
         */
        tabs.forEach(function (tab) {
            tab.addEventListener('click', function (e) {
                e.preventDefault();

                const tabName = this.dataset.tab;
                switchTab(tabName);
            });
        });

        /**
         * Escキーで閉じる
         */
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && search.classList.contains('is-open')) {
                closeSearch();
            }
        });
    }

    /**
     * ========================================
     * SPドロワーメニュー制御
     * ========================================
     */
    function initDrawer() {
        const drawer = document.querySelector('.p-custom-drawer');

        // 対象がなければ終了
        if (!drawer) return;

        // 二重初期化防止
        if (drawer.dataset.drawerInitialized === 'true') return;
        drawer.dataset.drawerInitialized = 'true';

        const drawerToggleButtons = document.querySelectorAll('.js-drawer-toggle');
        const drawerCloseButtons = drawer.querySelectorAll('.js-drawer-close');
        const accordionItems = drawer.querySelectorAll('.js-drawer-accordion');
        const animationDuration = 300;

        /**
         * ヘッダー上部のメニューボタン表示更新
         * - アイコン
         * - テキスト
         * - aria属性
         */
        function updateMenuButton(isOpen) {
            drawerToggleButtons.forEach(function (button) {
                const icon = button.querySelector('.p-custom-header__utility-icon img') || button.querySelector('.p-custom-header__bottom-nav-icon img');
                const text = button.querySelector('.p-custom-header__utility-text');
                const bottomNavText = button.querySelector('.p-custom-header__bottom-nav-text');
                const iconOpen = button.dataset.iconOpen;
                const iconClose = button.dataset.iconClose;

                button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                button.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');

                if (icon && iconOpen && iconClose) {
                    icon.src = isOpen ? iconClose : iconOpen;
                    icon.alt = isOpen ? '閉じる' : 'メニュー';
                }

                if (text) {
                    text.textContent = isOpen ? '閉じる' : 'メニュー';
                }

                if (bottomNavText) {
                    bottomNavText.textContent = isOpen ? '閉じる' : 'メニュー';
                }
            });
        }

        /**
         * ドロワーを開く
         */
        function openDrawer() {
            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
            document.documentElement.classList.add('is-drawer-open');
            updateMenuButton(true);
        }

        /**
         * ドロワーを閉じる
         */
        function closeDrawer() {
            drawer.classList.remove('is-open');
            drawer.setAttribute('aria-hidden', 'true');
            document.documentElement.classList.remove('is-drawer-open');
            updateMenuButton(false);
        }

        /**
         * ドロワー開閉トグル
         */
        function toggleDrawer() {
            if (drawer.classList.contains('is-open')) {
                closeDrawer();
            } else {
                openDrawer();
            }
        }

        /**
         * スライドで開く
         */
        function slideOpen(element) {
            element.style.transition = 'none';
            element.style.height = 'auto';
            const targetHeight = element.scrollHeight;

            element.style.height = '0px';
            element.style.overflow = 'hidden';
            element.offsetHeight;

            element.style.transition = 'height ' + animationDuration + 'ms ease';
            element.style.height = targetHeight + 'px';

            const onEnd = function (event) {
                if (event.propertyName !== 'height') return;

                element.style.transition = '';
                element.style.height = 'auto';
                element.style.overflow = '';
                element.removeEventListener('transitionend', onEnd);
            };

            element.addEventListener('transitionend', onEnd);
        }

        /**
         * スライドで閉じる
         */
        function slideClose(element) {
            element.style.height = element.scrollHeight + 'px';
            element.style.overflow = 'hidden';
            element.offsetHeight;

            element.style.transition = 'height ' + animationDuration + 'ms ease';
            element.style.height = '0px';

            const onEnd = function (event) {
                if (event.propertyName !== 'height') return;

                element.style.transition = '';
                element.style.overflow = '';
                element.removeEventListener('transitionend', onEnd);
            };

            element.addEventListener('transitionend', onEnd);
        }

        /**
         * アコーディオンを開く
         */
        function openAccordion(item) {
            const button = item.querySelector('.p-custom-drawer__toggle');
            const submenu = item.querySelector('.p-custom-drawer__submenu');

            if (!submenu) return;

            item.classList.add('is-open');

            if (button) {
                button.setAttribute('aria-expanded', 'true');
            }

            slideOpen(submenu);
        }

        /**
         * アコーディオンを閉じる
         */
        function closeAccordion(item) {
            const button = item.querySelector('.p-custom-drawer__toggle');
            const submenu = item.querySelector('.p-custom-drawer__submenu');

            if (!submenu) return;

            item.classList.remove('is-open');

            if (button) {
                button.setAttribute('aria-expanded', 'false');
            }

            slideClose(submenu);
        }

        /**
         * アコーディオン開閉
         * - 1つだけ開く仕様
         */
        function toggleAccordion(currentItem) {
            const isOpen = currentItem.classList.contains('is-open');

            // accordionItems.forEach(function (item) {
            //     if (item !== currentItem && item.classList.contains('is-open')) {
            //         closeAccordion(item);
            //     }
            // });

            if (isOpen) {
                closeAccordion(currentItem);
            } else {
                openAccordion(currentItem);
            }
        }

        /**
         * 初期状態セット
         */
        accordionItems.forEach(function (item) {
            const submenu = item.querySelector('.p-custom-drawer__submenu');
            const button = item.querySelector('.p-custom-drawer__toggle');

            if (submenu) {
                submenu.style.height = '0px';
                submenu.style.overflow = 'hidden';
            }

            if (button) {
                button.setAttribute('aria-expanded', 'false');

                button.addEventListener('click', function (event) {
                    event.preventDefault();
                    toggleAccordion(item);
                });
            }
        });

        /**
         * 開閉トリガー
         */
        drawerToggleButtons.forEach(function (button) {
            button.addEventListener('click', function (event) {
                event.preventDefault();
                toggleDrawer();
            });
        });

        /**
         * オーバーレイ・閉じるボタン
         */
        drawerCloseButtons.forEach(function (button) {
            button.addEventListener('click', function (event) {
                event.preventDefault();
                closeDrawer();
            });
        });

        /**
         * Escキーで閉じる
         */
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
                closeDrawer();
            }
        });
    }
})();